import React from 'react';
import { useContentVersionLinkModuleWithSalesChannelMode } from 'src/components/LinkModule/hooks';
import LinkLibrary from '@/src/constrains/LinkLibrary';
import { get } from 'lodash';

const _LinkLibrary = (props) => {
  const {
    error,
    data,
    onChange,
    salesChannelContentUuid,
    presetLinkTypeFilter,
    presetScopeVariables,
    presetExcludeLinkType,
    linkSet,
    salesChannelUuid,
    ...p
  } = props;

  const selectedSalesChannelUuid = get(data, 'salesChannelUuid');
  const _linkSet = useContentVersionLinkModuleWithSalesChannelMode({
    selectedSalesChannelUuid,
    salesChannelContentUuid: salesChannelContentUuid,
    presetLinkTypeFilter,
    presetScopeVariables,
    presetExcludeLinkType,
    salesChannelUuid,
  });

  const l = {
    ..._linkSet,
    ...(linkSet || {}),
  };
  return (
    <LinkLibrary
      error={(error || []).join(' ')}
      data={data}
      onChange={onChange}
      linkSet={l}
      {...(p || {})}
    />
  );
};
export default _LinkLibrary;
